import { render, staticRenderFns } from "./list_gcjs.vue?vue&type=template&id=17dd33b2&scoped=true"
import script from "./list_gcjs.vue?vue&type=script&lang=js"
export * from "./list_gcjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dd33b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17dd33b2')) {
      api.createRecord('17dd33b2', component.options)
    } else {
      api.reload('17dd33b2', component.options)
    }
    module.hot.accept("./list_gcjs.vue?vue&type=template&id=17dd33b2&scoped=true", function () {
      api.rerender('17dd33b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/businessWitnessHis/list_gcjs.vue"
export default component.exports